import { render, staticRenderFns } from "./SelectBoxInput.vue?vue&type=template&id=20f8f85c&scoped=true"
import script from "./SelectBoxInput.vue?vue&type=script&lang=js"
export * from "./SelectBoxInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f8f85c",
  null
  
)

export default component.exports